import { gql } from '@apollo/client';

export const fetchLinkedEntitlements = gql`
  query fetchLinkedEntitlements($id: String!, $searchLinkedEntitlementParams: SearchLinkedEntitlementParams!) {
    entitlementDetails(id: $id) {
      id
      transactionAccountId
      linkedEntitlements(searchLinkedEntitlementParams: $searchLinkedEntitlementParams) {
        entitlementId
        billingFrequency
        cloudSiteHostname
        cloudSiteId
        productId
        createdDate
        edition
        unitCount
        provisioningStatus
        baseProduct
        billingStatus
        billedUsers
        entitlementNumber
        productName
        transactionAccountId
        userTier
        trialEndDate
        endTimestamp
        trialStartDate
        latestPeriodEndDate
        latestPeriodStartDate
        isApp
        isSandbox
        activeUsers
        version
        relatesToEntitlements {
          entitlementId
          relationshipType
        }
        offering {
          pricingType
          id
          name
        }
        pricingPlan {
          id
          type
          billingFrequency
          tiers {
            unitAmount
            flatAmount
            floor
            ceiling
          }
        }
        trial
        logoId
        scheduledChanges {
          subscriptionScheduleAction
        }
        upgradeTrial {
          baseOfferingName
          offeringId
          offeringName
        }
        migrated
      }
    }
  }
`;
